module.exports = __webpack_public_path__ + "static/media/cjhy.1092e147.png";